import axios from 'axios';
import envService from "@/services/env.service";
import {logger} from "@/services/logger.service";

const BASE_URL = envService.getApiBaseUrl() + '/admin';

const SESSIONSTORAGE_CUSTOMERS = "customers";

export default {

    async getCustomers() {
        let data = sessionStorage.getItem(SESSIONSTORAGE_CUSTOMERS);
        if (data === undefined || data === null) {
            try {
                let response = await axios.get(BASE_URL + '/customers');
                if (response.status == 200) {
                    data = response.data;
                }
            } catch (e) {
                logger.error("Could not load customers");
                data = [];
            }
            sessionStorage.setItem(SESSIONSTORAGE_CUSTOMERS, JSON.stringify(data));
        } else {
            data = JSON.parse(data);
        }
        return data;
    },
    addCustomer(firstName, lastName, email) {
        let customers = sessionStorage.getItem(SESSIONSTORAGE_CUSTOMERS);
        customers = JSON.parse(customers);
        customers.push({firstName: firstName, lastName: lastName, email: email, apigeeOwnerEmail: email});
        sessionStorage.setItem(SESSIONSTORAGE_CUSTOMERS, JSON.stringify(customers));
    }
};
 